const ordersActionType = {
  // orders
  FETCH_ORDERS: "FETCH_ORDERS",
  FETCH_ORDERS_SUCCESS: "FETCH_ORDERS_SUCCESS",
  FETCH_ORDERS_FAILURE: "FETCH_ORDERS_FAILURE",
  // order notifications
  FETCH_ORDERS_NOTIFICATIONS: "FETCH_ORDERS_NOTIFICATIONS",
  FETCH_ORDERS_NOTIFICATIONS_SUCCESS: "FETCH_ORDERS_NOTIFICATIONS_SUCCESS",
  FETCH_ORDERS_NOTIFICATIONS_FAILURE: "FETCH_ORDERS_NOTIFICATIONS_FAILURE",
  // more orders
  FETCH_MORE_ORDERS_SUCCESS: "FETCH_MORE_ORDERS_SUCCESS",
  FETCH_MORE_ORDERS_FAILURE: "FETCH_MORE_ORDERS_FAILURE",
  // save product images
  SAVE_PRODUCT_IMGS: "SAVE_PRODUCT_IMGS",
  // delete order
  DELETE_ORDER: "DELETE_ORDER",
  DELETE_ORDER_SUCCESS: "DELETE_ORDER_SUCCESS",
  DELETE_ORDER_FAILURE: "DELETE_ORDER_FAILURE",
  // processing order payments
  PROCESSING_PAYMENTS: "PROCESSING_PAYMENTS",
  PROCESSING_PAYMENTS_SUCCESS: "PROCESSING_PAYMENTS_SUCCESS",
  PROCESSING_PAYMENTS_FAILURE: "PROCESSING_PAYMENTS_FAILURE",
  // export orders notifications
  EXPORT_ORDERS_NOTIFICATIONS_CSV: "EXPORT_ORDERS_NOTIFICATIONS_CSV",
  EXPORT_ORDERS_NOTIFICATIONS_CSV_SUCCESS: "EXPORT_ORDERS_NOTIFICATIONS_CSV_SUCCESS",
  EXPORT_ORDERS_NOTIFICATIONS_CSV_FAILURE: "EXPORT_ORDERS_NOTIFICATIONS_CSV_FAILURE",
  // search orders
  SEARCH_ORDERS: "SEARCH_ORDERS",
  SEARCH_ORDERS_SUCCESS: "SEARCH_ORDERS_SUCCESS",
  SEARCH_ORDERS_FAILURE: "SEARCH_ORDERS_FAILURE",
  // search order notifications
  SEARCH_ORDER_NOTIFICATIONS: "SEARCH_ORDER_NOTIFICATIONS",
  SEARCH_ORDER_NOTIFICATIONS_SUCCESS: "SEARCH_ORDER_NOTIFICATIONS_SUCCESS",
  SEARCH_ORDER_NOTIFICATIONS_FAILURE: "SEARCH_ORDER_NOTIFICATIONS_FAILURE",
  // order emails
  FIRESTORE_ORDER_EMAILS: "FIRESTORE_ORDER_EMAILS",
  FIRESTORE_ORDER_EMAILS_SUCCESS: "FIRESTORE_ORDER_EMAILS_SUCCESS",
  FIRESTORE_ORDER_EMAILS_FAILURE: "FIRESTORE_ORDER_EMAILS_FAILURE",
  // order pagination
  FIRESTORE_SET_TOTAL_ORDERS_COUNT: "FIRESTORE_SET_TOTAL_ORDERS_COUNT",
  // order notifications pagination
  FIRESTORE_SET_TOTAL_ORDERS_NOTIFICATIONS_COUNT: "FIRESTORE_SET_TOTAL_ORDERS_NOTIFICATIONS_COUNT",
};

export default ordersActionType;
